/* eslint react/display-name:0 */
import React from 'react';

const LocaleContext = React.createContext({ cc: 'us', lc: 'en' });

export const withLocaleContext = BaseComponent => props => (
    <LocaleContext.Consumer>
        {({ cc, lc }) => <BaseComponent cc={cc} lc={lc} {...props} />}
    </LocaleContext.Consumer>
);

export default LocaleContext;
